import React from "react";
import PropTypes from "prop-types";
import { H1, P } from "orcs-design-system";

import { copywriting } from "src/components/ErrorPage/ErrorPage.config";
import ErrorPageWrapper from "./ErrorPageWrapper";

const ServerError = ({ showHeader, showContainer }) => {
  return (
    <ErrorPageWrapper showHeader={showHeader} showContainer={showContainer}>
      <H1 mb="r">{copywriting.serverErrorHeading}</H1>
      <P>{copywriting.serverErrorDetail}</P>
    </ErrorPageWrapper>
  );
};

ServerError.propTypes = {
  showHeader: PropTypes.bool,
  showContainer: PropTypes.bool,
};

export default ServerError;
